// @flow strict
import * as React from 'react';
import styled, { type StyledComponent } from 'styled-components';

import type { ThemeInterface } from 'theme';
import { SearchForm } from 'components/common';

import TeamsQueryHelper from '../../security/components/teams-overview/TeamsQueryHelper';

type Props = {
  onSearch: (query: string) => void,
};

const Container: StyledComponent<{}, ThemeInterface, HTMLDivElement> = styled.div`
  margin-bottom: 10px;
`;

const SyncedTeamsFilter = ({ onSearch }: Props) => (
  <Container>
    <SearchForm onReset={() => onSearch('')}
                onSearch={onSearch}
                queryHelpComponent={<TeamsQueryHelper />}
                topMargin={0} />
  </Container>
);

export default SyncedTeamsFilter;
